import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";
import { theme } from "../../styles/theme";
import Container from "../../styles/Container";
import ReactStars from "react-stars";

const ReviewSection = styled.section`
  background: var(--blue);
  color: var(--grey);
  padding: 14rem 0;
`;
const ReviewTitle = styled.h1`
  text-transform: capitalize;
  margin-bottom: 2rem;
  font-size: 6rem;
  background: -webkit-linear-gradient(var(--white), #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const ReviewsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media ${theme.devices.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const ReviewArticle = styled.article`
  margin: 0 auto;
  border-radius: 0.7rem;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.13);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  box-shadow: ${theme.shadow.feature.big.default};
  @media ${theme.devices.md} {
    padding: 3rem;
  }
`;

const ReviewText = styled.p`
  /* font-size: clamp(1.1rem, 1.25vw, 2rem); */
  font-weight: 400;
`;
const User = styled.div`
  display: flex;
  align-items: center;
`;
const UserImage = styled.img`
  width: clamp(6rem, 5vw, 9rem);
  height: clamp(6rem, 5vw, 9rem);
  border-radius: 50%;
`;
const UserName = styled.h1`
  color: var(--white);
  margin-left: 2rem;
`;

export default function Reviews() {
  const { yelpapi } = useStaticQuery(graphql`
    query {
      yelpapi {
        business(id: "pure-pressure-mobile-wash-palmdale") {
          reviews {
            id
            user {
              name
              id
              image_url
            }
            text
            rating
          }
        }
      }
    }
  `);
  const { reviews } = yelpapi.business;
  return (
    <ReviewSection>
      <Container>
        <ReviewTitle>recent reviews</ReviewTitle>
        <ReviewsGrid>
          {reviews.map((review, index) => (
            <ReviewArticle key={index}>
              <ReactStars count={review.rating} size={24} color1={"#ffd700"} />
              <ReviewText>{review.text}</ReviewText>
              <User>
                <UserImage src={review.user.image_url} alt="A dinosaur" />
                <UserName>{review.user.name}</UserName>
              </User>
            </ReviewArticle>
          ))}
        </ReviewsGrid>
      </Container>
    </ReviewSection>
  );
}
